

































































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import ModalExportReport from '@/components/modals/ModalExportReport.vue'
import {NotasInseridasConfiguracao} from '@/model/resource/NotasInseridasConfiguracao'
import {InputNotasInseridasSchema} from '@/schema/resource/AcompanhamentoNotasInseridas/InputNotasInseridasSchema'

@Component({
  components: {ModalExportReport},
})
export default class PersistNotasInseridasConfiguracaoView extends Vue {
  @Provide('validator') validator = this.$validator

  schema = new InputNotasInseridasSchema()
  notasInseridas = new NotasInseridasConfiguracao()

  async created() {
    await this.populate()
  }

  @Watch('notasInseridas.responsavel')
  async populate() {
    const idResponsavel = this.notasInseridas?.responsavel?.$id

    if (idResponsavel) {
      const resp = await this.notasInseridas.getNotasInseridasConfiguracao(
        idResponsavel
      )
      if (!resp) {
        this.notasInseridas.reset()
        this.$snotify.warning(
          $.t('schema.InputFaturamentoConfiguracao.warning') as string
        )
      }
    } else {
      this.notasInseridas.reset()
    }

    $.await.done('getNotasInseridasConfiguracao')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.notasInseridas.persistNotasInseridasConfiguracao()
    this.$snotify.success(
      $.t('schema.InputNotasInseridasConfiguracao.success') as string
    )
    this.notasInseridas.restart()
    this.$forceUpdate()
  }

  get responsavelLabelAndValue() {
    if (this.notasInseridas.responsavel?.razaoSocial) {
      return {
        label: $.t('schema.InputNotasInseridasConfiguracao.razaoSocial'),
        value: this.notasInseridas.responsavel.razaoSocial,
      }
    } else {
      return {
        label: $.t('schema.InputNotasInseridasConfiguracao.nomeFantasia'),
        value: this.notasInseridas.responsavel?.nomeFantasia,
      }
    }
  }
}
